import React from "react";

import styles from "./Field.module.scss";

const Label = ({ id, label, isRequired }) => {
  const required = () => (isRequired ? <span className={styles.required}> *</span> : null);

  return (
    <label htmlFor={id} className={styles.label}>
      {label}
      {required()}
    </label>
  );
};

export default Label;
